import { useState } from "react"
import { useGalleryListQuery } from "@/service/api/gallery"
import { STAR_ID } from "@/shared/constants/star"
import type { ListRequest } from "@/shared/types/commonResponse"
import MainTitle from "../MainTitle"
import GalleryGridOne from "./components/GalleryGridOne"
import GalleryGridTwo from "./components/GalleryGridTwo"
import GalleryGridThree from "./components/GalleryGridThree"
import { useInView } from "react-intersection-observer"

const Gallery = () => {
  const [galleryList, setGalleryList] = useState<ListRequest>({
    Language: "en",
    angkorId: "",
    requestDto: {
      pageable: {
        page: 0,
        size: 1000,
        sort: [],
      },
      searchKeyword: "",
      starId: STAR_ID,
    },
  })

  const { ref, inView } = useInView({ triggerOnce: true })

  // API
  const { data: galleryListData } = useGalleryListQuery(galleryList, {
    enabled: inView,
  })

  const imageLength = galleryListData?.content?.length ?? 1

  return (
    <div className="mb-5" ref={ref}>
      <MainTitle title="Gallery" link="gallery" />

      {imageLength === 1 && (
        <GalleryGridOne galleryListData={galleryListData} />
      )}
      {imageLength === 2 && (
        <GalleryGridTwo galleryListData={galleryListData} />
      )}
      {imageLength >= 3 && (
        <GalleryGridThree galleryListData={galleryListData} />
      )}
    </div>
  )
}

export default Gallery
